// src/lib/api.js
import axios from "axios";

const isDev = process.env.NODE_ENV === "development";

// Base host (no trailing slash)
let apiHost = isDev
  ? "http://localhost:3001"
  : process.env.REACT_APP_API_BASE || "https://api.mychinesehoroscope.com";

// strip trailing slashes
apiHost = String(apiHost || "").replace(/\/+$/, "");

// Express mounts routes under /api
const apiBase = `${apiHost}/api`;

// token storage key
const TOKEN_KEY = "cz_token";

export const api = axios.create({
  baseURL: apiBase,
  withCredentials: true,
  timeout: 20000,
});

// ✅ Always send Authorization if token exists (cookie can fail sometimes)
api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization && !config.headers.authorization) {
        config.headers.Authorization = `Bearer ${t}`;
      }
    }
  } catch {}
  return config;
});

// helpers
export function setAuthToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, String(token));
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

export function getAuthToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}
